import { asyncRoutes, constantRoutes } from '@/router'
import Layout from '@/layout'
import {getMenu} from '@/api/menu'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise((resolve,reject) => {
       let accessedRoutes
      // //改成后端配置路由后，前端新增模块本地测试数据用
      //  accessedRoutes = filterAsyncRouter(asyncRoutes)
      //  commit("SET_ROUTES",accessedRoutes)
      //  resolve(accessedRoutes)
        getMenu().then(res => {
          const rolesData = filterAsyncRoutes(res.data,roles)
           accessedRoutes =  filterAsyncRouter(rolesData)
           commit('SET_ROUTES', accessedRoutes)
          resolve(accessedRoutes)
        }).catch(error => {
          reject(error)
        })
    })
  }
}

/**
 * 获取一个字符串值在指定字符串第n次出现的位置
 * @param str 字符串
 * @param cha 查找的字符
 * @param num 第一次出现, 从0开始
 * @returns {*}
 */
function find(str, cha, num) {
  var x = str.indexOf(cha)
  for (var i = 0; i < num; i++) {
    x = str.indexOf(cha, x + 1)
  }
  return x
}

/**
 * 将 用户菜单JSON信息 转换为 router 可识别的路由json信息
 * @param t 管理员菜单JSON数组
 * @returns {*}
 */
function filterAsyncRouter(t) {
  t.filter(index => {
    if (index.component === 'Layout') {
      index.component = Layout
    } else {
      // 不是路由菜单，转换对应 vue组件
      // @/views/sn-manage/dict/index
      let component = index.component

      //
      /**
       * 截取 示例 @/views/sn-manage/dict/index 截取出 @/viesw/ 以外的字符，因为 拼接会异常
       * 新逻辑： 创建页面的时候去掉 @/viesw/
       * @type {*|string}
       * let test = component.substr(find(component, '/', 1) + 1)
       */
      if(index.component)index.component = require(`@/views/${component}.vue`).default

    }
    // 递归子菜单
    if (index.children && index.children.length) {
      index.children = filterAsyncRouter(index.children)
    }
    return true
  })
  return t
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
